import { useEffect, useState } from "react";
import { ProjectCard } from "./ProjectCard";
import { Row } from "react-bootstrap";

function GitHubRepos() {
    const [repos, setRepos] = useState([]);
    const notNeededRepos = ['nottpande'];
    const token = "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"; // 🔒 Consider moving this to env

    useEffect(() => {
        fetch("https://api.github.com/users/nottpande/repos", {
            method: "GET",
            headers: {
                "Authorization": `token ${token}`,
                "Accept": "application/vnd.github.v3+json",
            },
        })
        .then((res) => res.json())
        .then((data) => {
            const filtered = data
                .filter(repo => !notNeededRepos.includes(repo.name))
                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
            setRepos(filtered);
        });
    }, []);

    return (
        <div>
            <Row>
                {repos.map((repo) => (
                    <ProjectCard
                        key={repo.id}
                        title={repo.name}
                        description={repo.description || "No description available"}
                        link={repo.html_url}
                    />
                ))}
            </Row>
        </div>
    );
}

export default GitHubRepos;